import BaseApi from "./BaseApi";
// import ApiHelper from "../helpers/ApiHelper";
import db from "../resources/db.json";

/**
 * 作業内容APIクラス
 *
 * @class WorkContentApi
 * @extends {BaseApi}
 */
class WorkContentApi extends BaseApi {
  /**
   * 作業内容詳細を取得する
   * @param {number} workId 作業ID
   * @return {AxiosPromise<any>} HTTPレスポンス
   * @throws {ApiError} WebAPIエラー
   * @memberof WorkContentApi
   */
  async get(workId) {
    const unfinished = db["unfinished-list"]?.body.data;
    const dispatch = db["dispatch-list"]?.body.data;
    const result = [...unfinished, ...dispatch].find(
      (l) => l.id === Number(workId),
    );
    return { data: { success: true, body: result } };

    // const axios = this.createRequest({
    //   headers: {
    //     "Content-Type": "application/json",
    //     Accept: "application/json",
    //   },
    // });

    // return new ApiHelper(this).requestWithApiTokenAutoRefreshMechanism(
    //   async () => axios.get(`/work-detail`),
    // );
  }

  /**
   * 間接作業内容詳細を取得する
   * @param {number} workId 作業ID
   * @return {AxiosPromise<any>} HTTPレスポンス
   * @throws {ApiError} WebAPIエラー
   * @memberof WorkContentApi
   */
  async getIndirect(workId) {
    return { data: db["indirect-work"] };

    // const axios = this.createRequest({
    //   headers: {
    //     "Content-Type": "application/json",
    //     Accept: "application/json",
    //   },
    // });

    // return new ApiHelper(this).requestWithApiTokenAutoRefreshMechanism(
    //   async () => axios.get(`/work-detail`),
    // );
  }

  /**
   * 無負荷作業内容詳細を取得する
   * @param {number} workId 作業ID
   * @return {AxiosPromise<any>} HTTPレスポンス
   * @throws {ApiError} WebAPIエラー
   * @memberof WorkContentApi
   */
  async getNoload(workId) {
    return { data: db["noload-work"] };

    // const axios = this.createRequest({
    //   headers: {
    //     "Content-Type": "application/json",
    //     Accept: "application/json",
    //   },
    // });

    // return new ApiHelper(this).requestWithApiTokenAutoRefreshMechanism(
    //   async () => axios.get(`/work-detail`),
    // );
  }

  /**
   * 停止ロス作業内容詳細を取得する
   * @param {number} workId 作業ID
   * @return {AxiosPromise<any>} HTTPレスポンス
   * @throws {ApiError} WebAPIエラー
   * @memberof WorkContentApi
   */
  async getStoploss(workId) {
    return { data: db["stoploss-work"] };

    // const axios = this.createRequest({
    //   headers: {
    //     "Content-Type": "application/json",
    //     Accept: "application/json",
    //   },
    // });

    // return new ApiHelper(this).requestWithApiTokenAutoRefreshMechanism(
    //   async () => axios.get(`/work-detail`),
    // );
  }

  /**
   * 直接作業を登録する
   * @param {object} params 作業データ
   * @return {AxiosPromise<any>} HTTPレスポンス
   * @throws {ApiError} WebAPIエラー
   * @memberof WorkContentApi
   */
  async createDirect(params) {
    return this.get(1);
  }
  /**
   * 直接作業を更新する
   * @param {number} workId 作業ID
   * @param {object} params 作業データ
   * @return {AxiosPromise<any>} HTTPレスポンス
   * @throws {ApiError} WebAPIエラー
   * @memberof WorkContentApi
   */
  async updateDirect(workId, params) {
    return this.get(workId);
  }
}
export default WorkContentApi;
